import clsx from "clsx";

/** 12 nodes: 2 + 4 + 6 rows (tree shape). */
const ROWS = [2, 4, 6];

interface GuildTreeNodeGridProps {
  nodeCount: number;
  activeNode: number | null;
  tapWindowSec: number;
  disabled?: boolean;
  onTap: (index: number) => void;
  gatheringNode: number | null;
}

export function GuildTreeNodeGrid({
  nodeCount,
  activeNode,
  disabled,
  onTap,
  gatheringNode,
}: GuildTreeNodeGridProps) {
  let index = 0;
  return (
    <div className="space-y-2">
      {ROWS.map((width, rowIdx) => {
        const cells = [];
        for (let c = 0; c < width && index < nodeCount; c += 1) {
          const nodeIndex = index;
          index += 1;
          const isActive = activeNode === nodeIndex;
          const isGather = gatheringNode === nodeIndex;
          cells.push(
            <button
              key={nodeIndex}
              type="button"
              disabled={disabled || !isActive}
              onClick={() => onTap(nodeIndex)}
              className={clsx(
                "rounded-xl border min-h-[52px] text-sm font-semibold transition-all",
                isGather && "border-emerald-400 bg-emerald-900/40 animate-pulse",
                !isGather &&
                  isActive &&
                  "border-amber-400 bg-amber-950/50 shadow-[0_0_12px_rgba(251,191,36,0.45)]",
                !isGather && !isActive && "border-kingdom-mid bg-kingdom-dark/70 opacity-80",
                disabled && "opacity-50 cursor-not-allowed",
              )}
            >
              {isGather ? "✨" : isActive ? "🔥" : "·"}
            </button>,
          );
        }
        return (
          <div
            key={rowIdx}
            className="grid gap-2"
            style={{ gridTemplateColumns: `repeat(${width}, minmax(0, 1fr))` }}
          >
            {cells}
          </div>
        );
      })}
    </div>
  );
}
